import { useCallback, useState } from 'react';

import documentsService from '../../domain/services/solicitation/documents.service';
import clientLogger from '../../domain/services/logging/client.logger';

const useTranscribeAudioDocument = () => {

    const [isTranscribing, setIsTranscribing] = useState(false);

    const transcribe = useCallback(async (requestId, documentId) => {

        if (!requestId || !documentId)
            return null;

        setIsTranscribing(true);

        try {
            return await documentsService.transcribeAudioDocument(requestId, documentId);
        } catch (error) {
            clientLogger.logClientError({
                context: 'audio:transcribe-document',
                message: 'Falha ao transcrever áudio do documento',
                payload: { requestId, documentId },
                error
            });
            return null;
        } finally {
            setIsTranscribing(false);
        }
    }, []);

    return { transcribe, isTranscribing };
};

export default useTranscribeAudioDocument;
